const i = window.env === 'PROD' ? 1 : 0

/**
 * 第三方域名配置
 * 数组第一个为测试环境，第二个为生产环境
 * */
const hosts = {
    cx: ['https://ucmp-wx-sit.sf-express.com/', 'https://ucmp.sf-express.com/'],
    mp: ['https://ucmp-wx-sit.sf-express.com/', 'https://mp.sf-express.com/'],
    strapi: ['https://www.sf-express.com/', 'https://www.sf-express.com/']
}

/**
 * 第三方url配置
 *
 * */
const urls = {
    /* ucmp ticket校验接口，用于登陆跳转 */
    CX_CHECK_TICKET: `${hosts.cx[i]}wxaccess/weixin/checkticket`,
    CX_UPLOAD: `${hosts.cx[i]}cx-wechat-member/member/feedBack/upload`,
    MP_CHECK_TICKET: `${hosts.mp[i]}cx-wechat-out/out/weixin/checkticket`,
    PRIVARY_POLICY: `${hosts.cx[i]}we/cxmodules/privacy-policy/home`,
    STRAPI_IMAGE: `${hosts.strapi[i]}`,
    AGING_INQUIRE: `${hosts.cx[i]}we/cx3.0/aging-inquire?channel=owf_mobile`
}

export { urls }



// WEBPACK FOOTER //
// ./src/constant/paths.js